import { createFileRoute } from '@tanstack/react-router';
import { ProposeTransferPage } from '@/components/app/ProposeTransferPage';

export const Route = createFileRoute('/app/works/$workId/transfer')({
  component: ProposeTransferRoute,
});

function ProposeTransferRoute() {
  const { workId } = Route.useParams();
  return <ProposeTransferPage workId={workId} />;
}
